<template lang="pug">
.item_card_vertical(
	v-bind:id='item.id',
	v-bind:class='classes',
	v-on:click='clickCard'
)
	.image(v-bind:style='{ backgroundImage: "url(" + imageUrl + ")" }')
	.text
		.trophy(v-if='classes.includes("trophy")')
		h5.date(v-if='item.datetime') {{ item.datetime }}
		h3.title {{ item.title }}
		h5.title_en(
			v-if='item.title_en && (classes.includes("nominee") || classes.includes("detail"))'
		) {{ item.title_en }}
		template(v-if='classes.includes("detail")')
			h5.desc {{ item.desc }}
			hr
		h4.brief(v-html='item.brief')
		.more(v-if='classes.includes("index")')
			.line 
			.content more
</template>

<script>
export default {
	props: ['item', 'classes', 'is_trophy'],
	methods: {
		clickCard: function () {
			if (this.classes && this.classes.includes('nominee')) {
				return;
			} else if (this.classes && this.classes.includes('detail')) {
				this.$router.push({
					name: 'Video',
					params: { id: this.item.id },
				});
			} else {
				this.$router.push({
					name: 'News',
					params: { id: this.item.id },
				});
			}
		},
	},
	computed: {
		imageUrl: function () {
			if (
				this.classes.includes('index') ||
				this.classes.includes('external_link')
			) {
				if (this.item.image !== '') {
					return this.item.image;
				} else {
					return require(`@/assets/images/demo.jpg`);
				}
			} else {
				if (!this.classes.includes('detail')) {
					return require(`@/${this.item.image}`);
				} else {
					if (this.item.image !== '') {
						return this.item.image;
					} else {
						return require(`@/assets/images/demo.jpg`);
					}
				}
			}
		},
	},
};
</script>

<style lang="stylus">
.item_card_vertical
	display: flex
	flex-wrap: wrap
	background-color: $color_dark
	border: 1px solid #082448
	border-radius: 15px
	margin-bottom: 1rem
	cursor: pointer
	.image, iframe
		position: relative
		flex-basis: 100%
		height: 220px
		border-radius: 15px 15px 0 0
		background-size: cover
		background-position: center center
		&:after
			content: ''
			position: absolute
			width: 100%
			height: 100%
			left: 0
			bottom: -1px
			background: linear-gradient(180deg, rgba(11, 46, 91, 0) 50%, #0B2E5B 100%)
	.text
		position: relative
		padding: 24px
		flex: 1
		.trophy
			position: absolute
			left: 24px
			top: -24px
			width: 25px
			height: 25px
			background-image: url('~@/assets/images/trophy.png')
		.date
			text-align: left
			margin-bottom: 4px
			color: $color_yellow
		.title, .brief, .title_en
			display: -webkit-box
			-webkit-box-orient: vertical
			overflow: hidden
			text-overflow: ellipsis
			line-height: 24px
		.title
			-webkit-line-clamp: 3
			height: 70px
			font-size: 1.125rem
			font-weight: 500
			text-align: justify
			margin-bottom: 24px
			color: white
		.title_en
			color: white
			line-height: 28px
		.brief
			-webkit-line-clamp: 2
			color: $color_light
			text-align: justify
			height: 48px
		.more
			display: flex
			align-items: center
			justify-content: flex-end
			font-weight: 500
			font-size: $fs-3
			color: $color_yellow
			.line
				width: 44px
				height: 0
				border: 1px solid $color_yellow
				margin: 3px 0.5rem 2px 3px
				display: inline-block
	&.index
		.text
			.brief
				min-height: 48px
	&.nominee
		.text
			.title
				height: unset
				margin-bottom: 0
			.title_en
				-webkit-line-clamp: 1
			.brief
				-webkit-line-clamp: unset
	&.detail
		display: none
		position: absolute
		width: 100%
		left: 50%
		top: 100%
		transform: translate(-50%, -50%)
		z-index: 10
		.text
			.title
				height: unset
				margin-bottom: 0
			.title_en
				text-align: left
				margin-bottom: 2rem
			.brief
				-webkit-line-clamp: 3
				height: unset
			hr
				color: #819EC6
				margin: 24px 0
			.desc
				text-align: justify
				color: #819EC6
		&.show
			display: flex
</style>
